import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const api = axios.create({ baseURL: `${API_BASE}/api` });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('hrtrack_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(r => r, err => {
  if (err.response?.status === 401) {
    localStorage.removeItem('hrtrack_token');
    localStorage.removeItem('hrtrack_user');
    window.location.reload();
  }
  return Promise.reject(err);
});

// Auth
export const login = (username, password) => api.post('/auth/login', { username, password }).then(r => r.data);
export const signup = (data) => api.post('/auth/signup', data).then(r => r.data);
export const verifyEmail = (token) => api.post('/auth/verify-email', { token }).then(r => r.data);
export const resendVerification = () => api.post('/auth/resend-verification').then(r => r.data);
export const forgotPassword = (email) => api.post('/auth/forgot-password', { email }).then(r => r.data);
export const resetPassword = (token, password) => api.post('/auth/reset-password', { token, password }).then(r => r.data);
export const getMe = () => api.get('/auth/me').then(r => r.data);
export const changePassword = (current_password, new_password) => api.post('/auth/change-password', { current_password, new_password }).then(r => r.data);

// Employees
export const getEmployees = () => api.get('/employees').then(r => r.data);
export const createEmployee = (data) => api.post('/employees', data).then(r => r.data);
export const updateEmployee = (id, data) => api.put(`/employees/${id}`, data).then(r => r.data);
export const deleteEmployee = (id) => api.delete(`/employees/${id}`).then(r => r.data);
export const resetEmployeePassword = (id, new_password) => api.post(`/employees/${id}/reset-password`, { new_password }).then(r => r.data);
export const forceClockOut = (employee_id) => api.post(`/time-entries/force-clock-out/${employee_id}`).then(r => r.data);

// Time entries
export const getTimeEntries = (params) => api.get('/time-entries', { params }).then(r => r.data);
export const getActiveEntry = (employee_id) => api.get(`/time-entries/active/${employee_id}`).then(r => r.data);
export const clockIn = (employee_id) => api.post('/time-entries/clock-in', { employee_id }).then(r => r.data);
export const clockOut = (employee_id) => api.post('/time-entries/clock-out', { employee_id }).then(r => r.data);
export const manualEntry = (data) => api.post('/time-entries/manual', data).then(r => r.data);
export const deleteEntry = (id) => api.delete(`/time-entries/${id}`).then(r => r.data);

// Dashboard
export const getDashboard = (params) => api.get('/dashboard', { params }).then(r => r.data);

// Reports
export const getReports = (params) => api.get('/reports/weekly', { params }).then(r => r.data);
export const getReportCSVUrl = (params) => {
  const token = localStorage.getItem('hrtrack_token');
  const qs = new URLSearchParams({ ...params, format: 'csv', _token: token }).toString();
  return `${API_BASE}/api/reports/weekly?${qs}`;
};

// Screenshots
export const getScreenshots = (params) => api.get('/screenshots', { params }).then(r => r.data);
export const uploadScreenshot = (formData) => api.post('/screenshots', formData).then(r => r.data);

// Activity
export const getActivity = (params) => api.get('/activity', { params }).then(r => r.data);
export const postActivity = (data) => api.post('/activity', data).then(r => r.data);

// Notifications
export const getNotifications = (params) => api.get('/notifications', { params }).then(r => r.data);
export const createNotification = (data) => api.post('/notifications', data).then(r => r.data);
export const markRead = (id) => api.put(`/notifications/${id}/read`).then(r => r.data);
export const markAllRead = () => api.put('/notifications/read-all').then(r => r.data);

// Settings
export const getSettings = () => api.get('/settings').then(r => r.data);
export const updateSettings = (data) => api.put('/settings', data).then(r => r.data);
export const uploadLogo = (formData) => api.post('/settings/logo', formData).then(r => r.data);
export const removeLogo = () => api.delete('/settings/logo').then(r => r.data);

// Workspace
export const getWorkspace = () => api.get('/workspace').then(r => r.data);
export const completeSetup = () => api.put('/workspace/setup-complete').then(r => r.data);

// Teams
export const getTeams = () => api.get('/teams').then(r => r.data);
export const createTeam = (data) => api.post('/teams', data).then(r => r.data);
export const updateTeam = (id, data) => api.put(`/teams/${id}`, data).then(r => r.data);
export const deleteTeam = (id) => api.delete(`/teams/${id}`).then(r => r.data);
export const addTeamMember = (teamId, employee_id) => api.post(`/teams/${teamId}/members`, { employee_id }).then(r => r.data);
export const removeTeamMember = (teamId, empId) => api.delete(`/teams/${teamId}/members/${empId}`).then(r => r.data);

// Risk Triggers
export const getRiskTriggers = () => api.get('/risk-triggers').then(r => r.data);
export const createRiskTrigger = (data) => api.post('/risk-triggers', data).then(r => r.data);
export const updateRiskTrigger = (id, data) => api.put(`/risk-triggers/${id}`, data).then(r => r.data);
export const deleteRiskTrigger = (id) => api.delete(`/risk-triggers/${id}`).then(r => r.data);

// Billing
export const getBilling = () => api.get('/billing').then(r => r.data);
export const createCheckout = (plan) => api.post('/billing/checkout', { plan }).then(r => r.data);
export const openPortal = () => api.post('/billing/portal').then(r => r.data);

export default api;
